import React from 'react';
import { Box, Skeleton } from '@mui/material';

const ShareSectionSkeleton: React.FC = () => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: 2,
      paddingBottom: 8,
      maxWidth: '768px',
      margin: '0 auto',
    }}>
    <Skeleton variant="rectangular" width="100%" height={1} sx={{ mb: 2 }} />
    <Skeleton variant="text" width={200} height={32} sx={{ mb: 2 }} />
    <Box sx={{
      display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1,
    }}>
      {Array.from({ length: 4 }).map((_, index) => (
        <Skeleton
          key={`share-skeleton-${index}`}
          variant="circular"
          width={40}
          height={40}
                    />
      ))}
    </Box>
  </Box>
);

export { ShareSectionSkeleton };
